import { ChemicalExposureForm } from '../forms/chemical-exposure.form';
import { IChemicalExposureRequest } from '../models/chemical-exposure.model';

export function createChemicalExposureForm(
  product?: {
    name?: string;
    maker?: string;
    chemicalExposure?: IChemicalExposureRequest;
  } | null
): ChemicalExposureForm {
  const existing = product?.chemicalExposure;
  const form = new ChemicalExposureForm({
    exposureDurationId: existing?.exposureDurationId ?? '',
    exposurePlacement: existing?.exposurePlacement ?? null,
    exposureLocation: existing?.exposureLocation ?? '',
    safetyDataSheetConfirmed: existing?.safetyDataSheetConfirmed ?? false,
    substanceName: existing?.substanceName ?? product?.name ?? '',
    manufacturerName: existing?.manufacturerName ?? product?.maker ?? '',
    exposedAt: existing?.exposedAt,
    exposedUserIds: existing?.exposedUserIds ?? [],
  });
  form.substanceName.disable({ emitEvent: false });
  form.manufacturerName.disable({ emitEvent: false });
  return form;
}
